import COLORS from '../styles/colors.json';
import {
    Box,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper
} from '@mui/material';

const STYLE = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)'
};

const COLUMNS = [
    'ODS PRODUCT ID',
    'CF SKU',
    'VOL SKU',
    'LSP CODE',
    'ORACLE SKU'
]

export default function ProductSkuTable({skus}) {
    console.log({skus})
    
    
    return (
        <Box sx={STYLE} >
            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label='invoice table'>
                    <TableHead>
                        <TableRow sx={{ backgroundColor: 'primary.light' }}>
                            {COLUMNS.map((column) =>
                                <TableCell
                                    sx={{ fontWeight: 600 }}
                                    key={column}
                                    align='right'
                                >
                                    {column}
                                </TableCell>)}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableCell align="right">{skus.ods_product_id}</TableCell>
                        <TableCell align="right">{skus.cf_sku}</TableCell>
                        <TableCell align="right">{skus.vol_sku}</TableCell>
                        <TableCell align="right">{skus.lsp_code}</TableCell>
                        <TableCell align="right">{skus.oracle_sku}</TableCell>
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
}